import { TabSwitcher } from "./TabSwitcher";

export function FallOffTree(Scene, GameObject,Delay)
{
    const Time = (900 - GameObject.y) * 1.2;
    //const Height 
    let Tween = Scene.addTween(GameObject,Time,{y: 900,delay:Delay},Phaser.Math.Easing.Quadratic.InOut);
    Tween.on('complete', ()=> {GameObject.destroy();});
}

export function TraySlide(Scene,GameObject, NeedsPromise)
{
    let Time = 300;
    if(NeedsPromise)
    {
        //console.log("Should wait here");
        return new Promise((resolve) => {
            let Tween = SlideInTween();
            Tween.on('complete',()=>{
                _ToggleTrayButtons(Scene, true);
                //console.log("Resolved")
                resolve('resolved');
                });
        })
    }
    else
    {
        SlideInTween();
    }

    function SlideInTween()
    {
        //Scene.GameAudio.play("drawer_open_close");
        Scene.AudioChan.Chan1.play("drawer_open_close");
        return Scene.addTween(GameObject,Time,{x: GameObject.x - 210},Phaser.Math.Easing.Quadratic.InOut);
    }
}

export function TraySlideOut(Scene, GameObject, NeedsPromise)
{
    let Time = 300;

    let Tween = SlideOutTween();
    if(NeedsPromise)
    {
        Tween.on('complete',()=>{
            _ToggleTrayButtons(Scene, true);
        });
        return Tween;
    }

    function SlideOutTween()
    {
        //Scene.GameAudio.play("drawer_open_close");
        Scene.AudioChan.Chan1.play("drawer_open_close");
        return Scene.addTween(GameObject,Time,{x: GameObject.x + 210},Phaser.Math.Easing.Quadratic.InOut);
    }
}

export function GroupTraySlide(Group, IntoTrayOutOfTray)
{
    let Scene = Group.scene;
    _ToggleTrayButtons(Scene,false);
    let func = TraySlide;
    if(IntoTrayOutOfTray === "Out")
    {
        Scene.CurrentTab.alpha = 1;
        func = TraySlideOut;
        TabTween(Scene,Scene.HelpBtn,IntoTrayOutOfTray);
        if(Scene.ActiveTree)
        {
            TabTween(Scene,Scene.CloseTrayBtn,IntoTrayOutOfTray);
        }
    }
    else
    {
        Scene.CurrentTab.alpha = 0;
    }

    Group.getChildren().forEach(element =>
        {
            func(element.scene,element);
        });

    func(Scene,Scene.HelpBtn);

    func(Scene,Scene.CloseTrayBtn);
    return func(Group.scene,Group.scene.Tray,true);
}

function _ToggleTrayButtons(Scene,Enable)
{
    if(Enable)
    {
        Scene.TrayButtons.forEach(Button =>
            {
                Button.setInteractive();
            });
    }
    else
    {
        Scene.TrayButtons.forEach(Button =>
            {
                Button.disableInteractive();
            });
    }
}

export function ToggleTrayItems(Group,Enable,Scene)
{
    // Group.getChildren().forEach(element =>
    //     {
    //         if(Enable)
    //         {
    //             element.setInteractive();
    //         }
    //         else if(!Enable)
    //         {
    //             element.disableInteractive();
    //         }
    //     });
    // if(Enable)
    // {
    //     //Scene.TreeForceBox.setInteractive();
    //     Scene.TreeForceBox.setDepth(Scene.DepthList.ArrowBtn);
    //     //console.log("Enable")
    //     //console.log(Scene.TreeForceBox);
    // }
    // else if(!Enable)
    // {
    //     //Scene.TreeForceBox.disableInteractive();
    //     Scene.TreeForceBox.setDepth(0);
    //     //console.log("disableable")
    // }
}

export function TabTween(Scene,TabItem,InOrOut)
{
    let ScaleTo = 0;
    if(InOrOut === "Out")
    {
        ScaleTo = 1;
    }
    return Scene.addTween(TabItem,300,{scaleY: ScaleTo},Phaser.Math.Easing.Bounce.Out);
}

export function TweenInButtons(object,TimeTaken,Ease = Phaser.Math.Easing.Linear,OffLeft = true)
{
    let Rotation;
    let Distance;
    let Scene = object[0].scene;

    for(let x in object)
    {

            Distance = 6.283 * object[x].width/2;
            Rotation = Distance/(object[x].width/2);

            if (OffLeft != true)
            {
                Distance = Distance * -1;
            }
            else
            {
                Rotation = Rotation * -1;
            }

            //console.log(Distance);

            Scene.addTween(object[x],TimeTaken,{rotation: Rotation, x: object[x].x - Distance},Ease);

    }
}

export function ChangeBackGroundFadeIn(Scene)
{
    const RectWidth = 50.5;
    let FadeInTween = Scene.addTween(Scene.ChangeButtons,100,{alpha:1});
    let Ease = Phaser.Math.Easing.Bounce.Out;
    FadeInTween.once('complete',()=>{
        Scene.addTween(Scene.ChangeButtons[0],300,{x:Scene.ChangeButtons[0].x - RectWidth},Ease);
        Scene.addTween(Scene.ChangeBackGroundMask,300,{scaleX:1},Ease);
        
        Scene.addTween(Scene.ChangeButtons[1],300,{x:Scene.ChangeButtons[1].x + RectWidth},Ease);
    });   
}

export function ChangeBackGroundFadeOut(Scene)
{
    const RectWidth = 50.5;
    //let FadeInTween = Scene.addTween(Scene.ChangeButtons,100,{alpha:0});
    let Ease = Phaser.Math.Easing.Bounce.Out;
    return new Promise((resolve) =>{
        Scene.addTween(Scene.ChangeButtons[0],300,{x:Scene.ChangeButtons[0].x + RectWidth},Ease);
        
        Scene.addTween(Scene.ChangeButtons[1],300,{x:Scene.ChangeButtons[1].x - RectWidth},Ease);
        Scene.addTween(Scene.ChangeBackGroundMask,300,{scaleX:0},Ease,()=>
        {
            Scene.addTween(Scene.ChangeButtons,100,{alpha:0},Phaser.Math.Easing.Linear,()=>{
                resolve(1);
            });
        });
    });
  
}

function _removeTreeForceBox(Scene)
{
    Scene.TreeForceBox.setAlpha(0);
    Scene.TreeForceBox.setPosition(0,0);
    Scene.TreeForceBox.setDepth(Scene.DepthList.ButtonBack);
    Scene.TreeForceBox.removeAllListeners();
    //Scene.TreeForceBox.on('pointerdown',()=>{//console.log("Hmmm")});
    Scene.TreeForceBox.input.alwaysEnabled = true;
    //console.log(Scene.TreeForceBox);
    //Scene.TreeForceBox.disableInteractive();
    //Scene.TreeForceBox.setAlpha(0);
    //Scene.TreeForceBox.destroy();
}

export function FirstTreeClick(Scene)
{
    TabTween(Scene,Scene.CloseTrayBtn,"Out");
    ChangeBackGroundFadeIn(Scene);
    TweenInButtons(Scene.MenuButtons,400,Phaser.Math.Easing.Quadratic.Out);
    _removeTreeForceBox(Scene);
    Scene.addTween(Scene.HelpMessage,200,{scaleX:1,hold:2000,yoyo:true},Phaser.Math.Easing.Bounce.InOut);
    Scene.addTween(Scene.HelpMessage,150,{scaleY:1,hold:2000,yoyo:true},Phaser.Math.Easing.Quadratic.InOut);
    for(let x in Scene.TrayButtons)
    {
        Scene.TrayButtons[x].setInteractive();
        Scene.TrayButtons[x].on('pointerdown',TabSwitcher);
    }
}